import { BaseService } from './base.service.js';
class PhoneService extends BaseService {
    async sendRegisterVerificationCode(dto) {
        return this.fetch('/phone/verification/register', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dto),
        });
    }
    async sendLoginVerificationCode(dto) {
        return this.fetch('/phone/verification/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dto),
        });
    }
    async sendResetVerificationCode(dto) {
        return this.fetch('/phone/verification/reset', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dto),
        });
    }
    async sendLinkVerificationCode(dto) {
        return this.fetch('/phone/verification/link', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dto),
        });
    }
}
export const phoneService = new PhoneService();
